import { useQuery, useMutation } from '@tanstack/react-query';

import { accountUserDetailKey } from '../common/queryKeys';
import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import AppApi from '../../../../../lib/api/app/AppApi';

export const useAccountUserCouponDetailQuery = ({ userId, pagination, filterOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'couponDetail', pagination, filterOption, userId],
    async () => {
      const result = await AccountUserApi.getAccountUserCouponDetail(
        setRequestForm({ userId, couponHistory: { filterOption, pagination } }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          couponHistoryList: {
            list: [],
            totalCnt: 0,
          },
        },
      },
    },
  );
};

export const useCheckValidGenerateCouponMutate = ({ userId, options }) => {
  return useMutation(
    [...accountUserDetailKey, 'couponDetail', 'generate', 'validCheck', userId],
    async (selectedCouponInfoList) => {
      const result = await AppApi.checkValidGenerateCoupon(
        setRequestForm({ selectedUserIdList: [userId], selectedCouponInfoList }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
    },
  );
};
